import { createContext, ComponentType, useState, useMemo } from 'react';

interface AtonemenetContextProviderValue {
    activeId: string | number | null;
    setActiveId: React.Dispatch<React.SetStateAction<string | number | null>>;
    otherSumValue: string;
    setOtherSumValue: React.Dispatch<React.SetStateAction<string>>;
    validate: boolean;
    setValidate: React.Dispatch<React.SetStateAction<boolean>>;
    errToShow: string | null;
    setErrToShow: React.Dispatch<React.SetStateAction<string | null>>;
}

interface ChildrenProps {
    children: React.ReactNode;
}

export const AtonementContext = createContext<AtonemenetContextProviderValue | null>(null);

export const AtonementProvider: ComponentType<ChildrenProps> = ({ children }) => {

    const [activeId, setActiveId] = useState<string | number | null>(null);
    const [otherSumValue, setOtherSumValue] = useState<string>("");
    const [validate, setValidate] = useState(false);
    const [errToShow, setErrToShow] = useState<string | null>(null);

    const value = useMemo(() => ({
        activeId,
        setActiveId,
        otherSumValue,
        setOtherSumValue,
        validate,
        setValidate,
        errToShow,
        setErrToShow
    }), [activeId,
        setActiveId,
        otherSumValue,
        setOtherSumValue,
        validate,
        setValidate,
        errToShow,
        setErrToShow])

    return (
        <AtonementContext.Provider value={value}>
            {children}
        </AtonementContext.Provider>
    )
}